<template lang="pug">
v-form
  app-card-title Организация
  app-text-field( v-model="form.orgTitle" label="Наименование организации" )
  app-text-field( v-model="form.orgPhone" label="Номер телефона организации" )
  app-text-field( v-model="form.orgAddress" label="Адрес организации" )
</template>

<script>
export default {
  name: "ExpertRegionOrganisationForm",
  props: {
    form: null,
  },
}
</script>